import { mutator } from 'satcheljs';
import { getStore } from '../store/Store';
import {
    setShowFolderPane,
    type SetShowFolderPaneActionMessage,
} from '../actions/setShowFolderPane';
import { logLeftPaneStateChange } from 'owa-left-pane-layout/lib/utils/logLeftPaneStateChange';
import {
    setLastCollapsedFolderPaneStateChangeSource,
    setLastExpandedFolderPaneStateChangeSource,
} from 'owa-left-pane-layout/lib/utils/folderPaneStateTracking';

/**
 * Sets showFolderPane value in store to passed in value
 * @param showFolderPane Whether to show folder pane
 */
const defaultExport: (actionMessage: SetShowFolderPaneActionMessage) => void =
    /* eslint-disable-next-line owa-custom-rules/prefer-mutator-action -- (https://aka.ms/OWALintWiki)
     * Baseline. DO NOT COPY AND PASTE!
     *	> Please use a mutatorAction if action is defined in the same package */
    mutator(setShowFolderPane, actionMessage => {
        getStore().showFolderPane = actionMessage.showFolderPane;
        if (actionMessage.showFolderPane) {
            getStore().showFolderPaneAsTransientOverlay = false;
        }

        if (actionMessage.newShowFolderPaneOverlayAsBlocking !== undefined) {
            getStore().showFolderPaneOverlayAsBlocking =
                actionMessage.newShowFolderPaneOverlayAsBlocking;
        }

        if (actionMessage.stateChangeSource === undefined) {
            return;
        }

        if (!actionMessage.showFolderPane) {
            setLastCollapsedFolderPaneStateChangeSource(actionMessage.stateChangeSource);
        } else {
            setLastExpandedFolderPaneStateChangeSource(actionMessage.stateChangeSource);
        }

        logLeftPaneStateChange(actionMessage.showFolderPane, actionMessage.stateChangeSource);
    });
export default defaultExport;
